import { useEffect } from 'react';

/**
 * Custom hook to manage focus in a ListBox component
 * Focuses the selected item or the first option when the ListBox becomes visible
 *
 * @param {Object} options - Hook options
 * @param {boolean} options.visible - Whether the ListBox is visible
 * @param {React.RefObject} options.listPickerRef - Ref to the ListBox component
 * @param {number|string} options.selectedValue - The currently selected value
 * @returns {void}
 */
const useListBoxFocus = ({ visible, listPickerRef, selectedValue }) => {
  useEffect(() => {
    if (visible && listPickerRef.current) {
      setTimeout(() => {
        const selectedByAttr = listPickerRef.current?.querySelector('[aria-selected="true"]');
        const selectedByClass = selectedByAttr || listPickerRef.current?.querySelector('.andes-list__item--selected');
        if (selectedByClass) {
          selectedByClass.focus();
        } else {
          const firstOption = listPickerRef.current?.querySelector('li[role="option"]');
          if (firstOption) {
            firstOption.focus();
          }
        }
      }, 50);
    }
  }, [visible, selectedValue, listPickerRef]);
};

export default useListBoxFocus;
